import api from './'

export function login(username, password){
  return api.post('/auth', { username, password })
}